const vendorApi = {
  GET_ALL_VENDORS: `/api/restaurant/vendor/all`,
  CREATE_VENDOR: `/api/restaurant/vendor/create`,
  UPDATE_VENDOR: `/api/restaurant/vendor/update`,
  DELETE_VENDOR: `/api/restaurant/vendor/delete`,
};

export default vendorApi;
